export const includeInSearch = (name?: string, searchValue?: string) => {
  if (name && searchValue) return name?.toLowerCase()?.includes(searchValue.toLowerCase());

  return true;
};
